<template>
  <h3>基本信息</h3>
  <el-form
    :disabled="status === 3"
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="120px"
    class="userForm"
  >
    <div style="text-align: center">
      <el-upload
        :action="'/api/hz-smart-community/sys/file/upload'"
        list-type="picture-card"
        :headers="{
          token: token,
        }"
        :show-file-list="false"
        :on-success="handlePictureCardPreview"
        :limit="1"
      >
        <el-icon v-if="!ruleForm.imageUrl">
          <plus />
        </el-icon>
        <img v-else :src="imgURL + ruleForm.imageUrl" />
      </el-upload>
    </div>
    <div class="formTitle"><span></span>房屋基本信息</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="房屋类别" prop="houseType">
          <el-select
            v-model="ruleForm.houseType"
            placeholder="房屋类别"
            :style="{ width: '320px' }"
          >
            <el-option
              v-for="(item, index) in houseTypeList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="房屋用途" prop="houseUsage">
          <el-select v-model="ruleForm.houseUsage" placeholder="房屋用途">
            <el-option
              v-for="(item, index) in housePurposeTypeList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="房屋性质" prop="houseProperty">
          <el-select
            v-model="ruleForm.houseProperty"
            placeholder="房屋性质"
            :style="{ width: '320px' }"
          >
            <el-option
              v-for="(item, index) in housePropertyList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="居住现状" prop="houseLive">
          <el-select v-model="ruleForm.houseLive" placeholder="居住现状">
            <el-option
              v-for="(item, index) in houseRentTypeList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="房屋间数" prop="">
          <el-input
            v-model="ruleForm.houseNumber"
            placeholder="房屋间数"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="房屋面积" prop="">
          <el-input
            v-model="ruleForm.houseSpace"
            placeholder="房屋面积"
            :style="{ width: '217px' }"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="产权编号" prop="">
          <el-input
            v-model="ruleForm.houseCode"
            placeholder="产权编号"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <div class="formTitle"><span></span>房屋地址</div>
    <el-form-item label="房屋地址" prop="">
      <el-input
        disabled
        v-model="ruleForm.houseAddress"
        placeholder="房屋地址"
      ></el-input>
    </el-form-item> -->
    <div class="formTitle"><span></span>房屋所属单位</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="单位编码" prop="">
          <el-input
            v-model="ruleForm.unitCode"
            placeholder="单位编码"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="单位名称" prop="">
          <el-input
            v-model="ruleForm.unitName"
            placeholder="单位名称"
            :style="{ width: '217px' }"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle"><span></span>房主信息</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="姓名" prop="ownerName">
          <el-input v-model="ruleForm.ownerName" placeholder="姓名"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="证件类型" prop="ownerCardType">
          <el-select v-model="ruleForm.ownerCardType" placeholder="证件类型">
            <el-option
              v-for="(item, index) in cardList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="证件号码" prop="ownerCardNumber">
          <el-input
            v-model="ruleForm.ownerCardNumber"
            placeholder="证件号码"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="ownerTelphone">
          <el-input
            v-model="ruleForm.ownerTelphone"
            placeholder="联系电话"
            :style="{ width: '217px' }"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle"><span></span>托管人信息</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="姓名" prop="">
          <el-input
            v-model="ruleForm.trusteeName"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="证件类型" prop="">
          <el-select v-model="ruleForm.trusteeCardType" placeholder="证件类型">
            <el-option
              v-for="(item, index) in cardList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="证件号码" prop="">
          <el-input
            v-model="ruleForm.trusteeCardNumber"
            placeholder="证件号码"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="">
          <el-input
            v-model="ruleForm.trusteeTelphone"
            placeholder="联系电话"
            :style="{ width: '217px' }"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="与房主关系" prop="">
          <el-select
            v-model="ruleForm.trusteeOrOwner"
            placeholder="与房主关系"
            :style="{ width: '320px' }"
          >
            <el-option
              v-for="(item, index) in homeList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <div class="formTitle"><span></span>其他信息</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="备注" prop="">
          <el-input v-model="ruleForm.comment" placeholder="备注"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="登记人姓名" prop="">
          <el-input
            disabled
            v-model="ruleForm.userName"
            placeholder="登记人姓名"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="登记单位" prop="">
          <el-input
            disabled
            v-model="ruleForm.userDeptName"
            placeholder="登记单位"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="登记时间" prop="">
          <el-input
            disabled
            v-model="ruleForm.createTime"
            placeholder="登记时间"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row> -->
  </el-form>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
} from "vue";
import util from "@util/js";
import { ElMessage } from "element-plus";
import { saveQuery, updateQuery, infoQuery } from "@/api/realHouse/realHouse";
import { Plus } from "@element-plus/icons-vue";
import _ from "lodash";
import { getDict } from "@/api/constant";
import Validate from "@/utils/validate.js";
export default defineComponent({
  name: "",
  components: { Plus },
  props: {
    validateCorrect: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      token: localStorage.getItem("token"),
      imgURL: window.imgURL,
      defaultPassword: "kzga110",
      formVisible: false,
      passwordType: 1,
      ruleForm: {
        imageUrl: "",
        houseType: "", // 房屋类别
        houseUsage: "", // 房屋用途
        houseProperty: "", // 房屋性质
        houseLive: "", // 居住现状
        houseNumber: "", // 房屋间数
        houseSpace: "", // 房屋面积
        houseCode: "", // 产权编号
        houseAddress: "", // 房屋地址
        unitCode: "", // 单位编码
        unitName: "", // 单位名称
        ownerName: "", // 房主姓名
        ownerCardType: "", // 房主证件类型
        ownerCardNumber: "", // 房主证件号码
        ownerTelphone: "", // '联系电话
        trusteeName: "", // 托管人姓名
        trusteeCardType: "", // 托管人证件类型
        trusteeCardNumber: "", // 托管人证件号码
        trusteeTelphone: "", // 托管人联系电话
        trusteeOrOwner: "", // 托管人与房主关系
        comment: "", // 备注
        createTime: "",
        updateTime: "",
        userName: "",
        userDeptName: "",
      },
      homeList: [],
      housePropertyList: [], // 房屋性质
      housePurposeTypeList: [], // 房屋用途
      houseTypeList: [], // 房屋类别
      houseRentTypeList: [], // 居住现状
      codeList: [],
      cardList: [],
      ruleFormBack: {},
      rules: {
        houseType: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        houseUsage: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        houseProperty: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        houseLive: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        ownerName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],

        ownerCardType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur",
          },
        ],
        // ownerCardNumber: [
        //   {
        //     required: true,
        //     message: "请输入身份证号",
        //     trigger: "blur",
        //   },
        // ],
        // ownerTelphone: [
        //   {
        //     required: true,
        //     message: "请输入电话号码",
        //     trigger: "blur",
        //   },
        // ],
      },
      options: [],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    const refData = toRefs(state);
    watchEffect(() => {
      if (props.status === 1 || props.status === 2) {
        state.rules.ownerCardNumber = [
          {
            required: true,
            validator: validate.iDCards,
            trigger: "blur",
          },
        ];
        state.rules.ownerTelphone = [
          {
            required: true,
            validator: validate.tels,
            trigger: "blur",
          },
        ];
      }
    });
    watchEffect(() => {
      if (
        !state.ruleForm.ownerCardType ||
        state.ruleForm.ownerCardType == "0" ||
        state.ruleForm.ownerCardType == "1"
      ) {
        state.rules.ownerCardNumber = [
          {
            required: true,
            validator: validate.iDCards,
            trigger: "blur",
          },
        ];
      } else {
        state.rules.ownerCardNumber = null;
      }
    });
    // 初始化表单
    const initForm = async () => {
      if (props.status !== 1) {
        state.passwordType = 2;
      }
      if (props.status === 2) {
        const res = await infoQuery(props.form.houseId);
        const form = { ...state.ruleForm, ...res.prisonInfo };
        state.ruleForm = _.cloneDeep(form);
      }
      const form = { ...state.ruleForm, ...props.form };
      state.ruleForm = _.cloneDeep(form);
    };
    // 监听
    // watch(
    //   () => state.formVisible,
    //   (v) => {
    //     initForm();
    //   }
    // );
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.validateCorrect;
      initForm();
    });

    // watchEffect(() => {
    //   context.emit("update:modelValue", state.formVisible);
    // });

    // 保存表单数据
    const submitOne = (formEl) => {
      console.log(state.ruleForm);
      ruleFormRef.value.validate(async (valid) => {
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          form.deptId = props.form.parentId;
          util.formatForm(form);
          let res;
          if (props.status === 1) {
            res = await saveQuery(form);
          } else if (props.status === 2) {
            form.status = 1;
            res = await updateQuery(form);
            // res = form;
          } else if (props.status === 4) {
            res = await updateQuery(form);
            // res = form;
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            // context.emit("clone", state.formVisible);
            context.emit("validateCorrect", true);
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    // 获取数据字典
    const queryMenuType = async () => {
      // nationType 民族 card_type证件类型 marital_type婚姻状况 householdType一致不一致
      // rentRelationType 与房主关系 job_type职业类别 countryType 国际
      // housePropertyType 房屋性质 housePurposeType 房屋用途 houseType 房屋类别  houseRentType居住现状
      const home = await getDict("rentRelationType");
      const houseProperty = await getDict("housePropertyType");
      const housePurposeType = await getDict("housePurposeType");
      const houseType = await getDict("houseType");
      const houseRentType = await getDict("houseRentType");
      const card = await getDict("card_type");

      state.homeList = home.dict;
      state.housePropertyList = houseProperty.dict;
      state.housePurposeTypeList = housePurposeType.dict;
      state.houseTypeList = houseType.dict;
      state.houseRentTypeList = houseRentType.dict;
      state.cardList = card.dict;
    };

    queryMenuType();
    const handlePictureCardPreview = (file) => {
      state.ruleForm.imageUrl = file.data.fileUrl;
    };
    return {
      ...refData,
      handlePictureCardPreview,
      submitOne,
      ruleFormRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.userForm {
  width: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
.formTitle {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span {
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.margLeftLabel {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
